export const TRANSLATION_KEYS = {
  noPortalAccessWarning: 'cng-contact-editor-dialog--no-portal-access-warning-message',
  dialog: {
    iqWarning: {
      title: 'cng-contact-editor-dialog--iq-warning-title',
      message: 'cng-contact-editor-dialog--iq-warning-message',
      confirm: 'cng-contact-editor-dialog--iq-warning-confirm',
    },
    blockedFlagWarning: {
      title: 'cng-contact-editor-dialog--blocked_flag-warning-title',
      message: 'cng-contact-editor-dialog--blocked_flag-warning-message',
      confirm: 'cng-contact-editor-dialog--blocked_flag-warning-confirm',
    },
    ppaWarning: {
      title: 'cng-contact-editor-dialog--ppa-warning-title',
      message: 'cng-contact-editor-dialog--ppa-warning-message',
      confirm: 'cng-contact-editor-dialog--ppa-warning-confirm',
    },
  },
}
